import { Component, inject } from '@angular/core';
import { LoaderService } from '../../services/loader.service';

@Component({
  selector: 'app-page-loader',
  standalone: true,
  template: `
    @if (loader.visible()) {
      <div class="page-loader" role="status" aria-live="polite" aria-label="Loading">
        <span class="material-icons page-loader-spinner" aria-hidden="true">progress_activity</span>
      </div>
    }
  `,
  styleUrl: './page-loader.component.scss',
})
export class PageLoaderComponent {
  protected readonly loader = inject(LoaderService);
}
